import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Patient {
  user_id: string;
  name: string;
  phoneNumber: string;
  found?: boolean;
  created?: boolean;
}

interface PatientState {
  selectedPatient: Patient | null;
  searchResults: Patient[];
  searchLoading: boolean;
  searchError: string | null;
}

const initialState: PatientState = {
  selectedPatient: null,
  searchResults: [],
  searchLoading: false,
  searchError: null,
};

const patientSlice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    setSelectedPatient: (state, action: PayloadAction<Patient | null>) => {
      state.selectedPatient = action.payload;
    },
    setSearchResults: (state, action: PayloadAction<Patient[]>) => {
      state.searchResults = action.payload;
    },
    setSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.searchLoading = action.payload;
    },
    setSearchError: (state, action: PayloadAction<string | null>) => {
      state.searchError = action.payload;
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.searchError = null;
    },
    clearSelectedPatient: (state) => {
      state.selectedPatient = null;
    },
  },
});

export const {
  setSelectedPatient,
  setSearchResults,
  setSearchLoading,
  setSearchError,
  clearSearchResults,
  clearSelectedPatient,
} = patientSlice.actions;

export default patientSlice.reducer;
